import React from "react";
import {
  displayNullFormatter,
  displayCommaFormatter,
  commonStyle,
  commonHeaderStyle,
  rowStyle2,
} from "../Utility/utility";
import "../style.css";
import BootstrapTable from "react-bootstrap-table-next";

const View2BColumnsTable = (props) => {
  const View2BColumns = [
    {
      dataField: "INV_TYP",
      text: "Section Name",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "INV_TYP"),
    },
    {
      dataField: "USER_GSTN",
      text: "Taxpayer GSTIN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "USER_GSTN"),
    },

    {
      dataField: "RET_PERIOD",
      text: "Return Period",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "RET_PERIOD"),
    },
    {
      dataField: "ctin",
      text: "GSTIN/ UIN of Counterparty",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "ctin"),
    },
    {
      dataField: "trdnm",
      text: "Name of Counterparty",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "trdnm"),
    },
    {
      dataField: "inum",
      text: "Invocie/ Document Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      // formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "inum"),
      formatter: (cell, row) => {
              return row?.INV_TYP === 'CDN' || row?.INV_TYP === 'CDNA' ? '--' :
              displayNullFormatter(row.FILE_JSON, "inum")
            },
    },

    {
      dataField: "typ",
      text: "Invoice Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      // formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "inv_typ"),
      formatter: (cell, row) => {
              return row?.INV_TYP === 'CDN' || row?.INV_TYP === 'CDNA' ? '--' :
              displayNullFormatter(row.FILE_JSON, "typ")
            },
    },
    {
      dataField: "dt",
      text: "Invoice/ Document Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => {
              return row?.INV_TYP === 'CDN' || row?.INV_TYP === 'CDNA' ? '--' :
              displayNullFormatter(row.FILE_JSON, "dt")
            },
      // formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "dt"),
    },
    {
      dataField: "val",
      text: "Total Invoice",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => {
              return row?.INV_TYP === 'CDN' || row?.INV_TYP === 'CDNA' ? '--' :
              displayCommaFormatter(row.FILE_JSON, "val")
            },
      // formatter: (cell, row) => displayCommaFormatter(row.FILE_JSON, "val"),
    },
    {
      dataField: "typ",
      text: "Note Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => {
              return row?.INV_TYP !== 'CDN' && row?.INV_TYP !== 'CDNA' ? '--' :
              displayNullFormatter(row.FILE_JSON, "typ")
            },
      // formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "typ"),
    },
    {
      dataField: "nt_num",
      text: "Note Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => {
              return row?.INV_TYP !== 'CDN' && row?.INV_TYP !== 'CDNA' ? '--' :
              displayNullFormatter(row.FILE_JSON, "nt_num")
            },
      // formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "nt_num"),
    },
    {
      dataField: "suptyp",
      text: "Note Supply Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => {
              return row?.INV_TYP !== 'CDN' && row?.INV_TYP !== 'CDNA' ? '--' :
              displayNullFormatter(row.FILE_JSON, "suptyp")
            },
      // formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "suptyp"),
    },
    {
      dataField: "dt",
      text: "Note Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => {
              return row?.INV_TYP !== 'CDN' && row?.INV_TYP !== 'CDNA' ? '--' :
              displayNullFormatter(row.FILE_JSON, "dt")
            },
      // formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "dt"),
    },
    {
      dataField: "val",
      text: "Note Value",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
       formatter: (cell, row) => {
              return row?.INV_TYP !== 'CDN' && row?.INV_TYP !== 'CDNA' ? '--' :
              displayCommaFormatter(row.FILE_JSON, "val")
            },
      // formatter: (cell, row) => displayCommaFormatter(row.FILE_JSON, "val"),
    },
    {
      dataField: "oinum",
      text: "Original Invoice Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "oinum"),
    },
    {
      dataField: "oidt",
      text: "Original Invoice Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "oidt"),
    },
    {
      dataField: "ontnum",
      text: "Original Note Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "ontnum"),
    },
    {
      dataField: "ontdt",
      text: "Original Note Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "ontdt"),
    },
    {
      dataField: "pos",
      text: "Place of Supply",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "pos"),
    },
    {
      dataField: "rev",
      text: "Whether reverse charge is applicable",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "rev"),
    },
    {
      dataField: "txval",
      text: "Taxable Value",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayCommaFormatter(row.FILE_JSON, "txval"),
    },
    {
      dataField: "iamt",
      text: "IGST Amount",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayCommaFormatter(row.FILE_JSON, "iamt"),
    },
    {
      dataField: "camt",
      text: "CGST Amount",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayCommaFormatter(row.FILE_JSON, "camt"),
    },
    {
      dataField: "samt",
      text: "SGST Amount",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayCommaFormatter(row.FILE_JSON, "samt"),
    },
    {
      dataField: "csamt",
      text: "Cess Amount",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayCommaFormatter(row.FILE_JSON, "csamt"),
    },
    {
      dataField: "supfildt",
      text: "Date of filing GSTR1/5 of supplier",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "supfildt"),
    },
    {
      dataField: "supprd",
      text: "Filing period of GSTR6 of supplier",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "supprd"),
    },
    {
      dataField: "itcelg",
      text: "Eligible for ITC",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "itcelg"),
    },
    {
      dataField: "itcavl",
      text: "ITC Availability",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "itcavl"),
    },
    {
      dataField: "rsn",
      text: "Reason",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "rsn"),
    },
    {
      dataField: "odoctyp",
      text: "Original ISD Document Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "odoctyp"),
    },
    {
      dataField: "odocnum",
      text: "Original ISD Document Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "odocnum"),
    },
    {
      dataField: "odocdt",
      text: "Original ISD Document Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "odocdt"),
    },
    {
      dataField: "doctyp",
      text: "ISD Document Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "doctyp"),
    },
    {
      dataField: "docnum",
      text: "ISD Document Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "docnum"),
    },
    {
      dataField: "docdt",
      text: "ISD Document Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "docdt"),
    },
    {
      dataField: "supprd",
      text: "Filing period of GSTR1/5 of supplier",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "supprd"),
    },
    {
      dataField: "fail9",
      text: "Original Tax Period",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "fail9"),
    },
    {
      dataField: "fail10",
      text: "Amendment made, if any",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "ret_period"),
    },
    {
      dataField: "fail11",
      text: "Tax Period in which Amended",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "ret_period"),
    },
    {
      dataField: "refdt",
      text: "Reference date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "refdt"),
    },
    {
      dataField: "portcode",
      text: "Port Code",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "portcode"),
    },
    {
      dataField: "benum",
      text: "Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "benum"),
    },
    {
      dataField: "RET_PERIOD",
      text: "Tax Period",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "RET_PERIOD"),
    },
    {
      dataField: "fail16",
      text: "Effective date of cancellation",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "ret_period"),
    },
    {
      dataField: "srctyp",
      text: "Source",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "srctyp"),
    },
    {
      dataField: "irn",
      text: "IRN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row.FILE_JSON, "irn"),
    },
    {
      dataField: "irngendate",
      text: "IRN Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) =>
        displayNullFormatter(row.FILE_JSON, "irngendate"),
    },
    {
      dataField: "MATCH_MONTH",
      text: "Match Month",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => {
        // Show Match Month only when reconciliation status is 'Matched'
        if (!row || String(row.RECO_STATUS) !== "Matched") return "";
        return displayNullFormatter(row, "MATCH_MONTH");
      },
    },
    {
      dataField: "MARK_3B_MONTH",
      text: "Mark in 3B Month",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "1.95%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "MARK_3B_MONTH"),
    },
    {
      dataField: "RECO_STATUS",
      text: "Reco Status",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "2.5%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "RECO_STATUS"),
    },
  ];
  return (
   
        <BootstrapTable
          keyField="ID"
          data={props.viewTableData}
          columns={View2BColumns}
          rowStyle={rowStyle2}
        />
     
  );
};

export default View2BColumnsTable;
